<template>
  <div class="container platform-config-page">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>配置管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单类型</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">工单类型</div>
    <el-card class="box-card">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="index" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="svr_item" align="center">
          <template slot="header">
            <div>服务项</div>
            <div>svr_item</div>
          </template>
        </el-table-column>
        <el-table-column prop="all_tp" align="center">
          <template slot="header">
            <div>all_tp</div>
          </template>
        </el-table-column>
        <el-table-column prop="tp1" align="center" width="100">
          <template slot="header">
            <div>tp1</div>
          </template>
        </el-table-column>
        <el-table-column prop="tp2" align="center" width="100">
          <template slot="header">
            <div>tp2</div>
          </template>
        </el-table-column>
        <el-table-column prop="tp3" align="center" width="100">
          <template slot="header">
            <div>tp3</div>
          </template>
        </el-table-column>
        <el-table-column prop="tp4" align="center" width="100">
          <template slot="header">
            <div>tp4</div>
          </template>
        </el-table-column>
        
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getPoServiceTypes } from '@/api/skill';
export default {
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      tableData: [],
    };
  },
  created() {
    this.getPoServiceTypes();
  },
  methods: {
    getPoServiceTypes() {
      getPoServiceTypes().then((res) => {
        if (res.data) {
          this.tableData = res.data.data.data.map(item => ({
            svr_item: item.svr_item,
            tp1: item.tp1,
            tp2: item.tp2,
            tp3: item.tp3,
            tp4: item.tp4,
            all_tp: item.all_tp
          }));
        }
      });
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}
</style>